//头部组件  元素标题 设置图标等
import React from 'react';
import { ELEMENT_TYPES } from '../../constants/ActionTypes';
import { isEqual, isEmpty } from 'lodash';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import { onShowOrHideE } from '../../util/common';
import { dragStart } from '../../util/drag';
import Toolbar from '../common/Toolbar';
import TitleTabPane from './TitleTabPane';

class EHeader extends React.Component {
  constructor(props) {
      super(props);
      this.state = {}
      this.handleDragStart = this.handleDragStart.bind(this);
      this.setPosition = this.setPosition.bind(this);
  }
  handleDragStart(event){
      const { config, handleRefresh } = this.props;
      if(!config.item.header.onmousedown) return;
      let callback;
      if(config.item.ebaseid === ELEMENT_TYPES.CUSTOMPAGE) callback = handleRefresh;
      dragStart(event, event.target, callback);
  }
  componentDidMount(){
    this.setPosition();
  }
  componentDidUpdate(){
    this.setPosition();
  }
  setPosition() {
    const { config } = this.props;
    const { left, width } = this.state;
    const { eid } = config.item;
    const titleWidth= $(`#title_${eid}`).width();
    const titleLeft= $(`#title_${eid}`).position() && $(`#title_${eid}`).position().left;
    const toolbarWidth= $(`#toolbar_${eid}`).width();
    if((!width || !isEqual(width, titleWidth+titleLeft+90+20+5)) && titleWidth != null) {
        this.setState({
            left: titleWidth + titleLeft + 10,
            width: titleWidth+titleLeft+90+20+5
        })
    }
  }
  render() {
      const {left=0, width=0} = this.state;
      const { config, handleRefresh, handleDelete, fontSizeMp = {}, datas={} } = this.props;
      const {tabids=[]} = datas;
      const { eid, header, ebaseid } = config.item;
      let { fontStyle = {} } = config.item;
      if(!isEmpty(fontSizeMp)){
          fontStyle = fontSizeMp;
      }
      let className = tabids.length <= 1 ? 'nodisplay' : '';
      return <div className="header" style={header.style}
            data-issetting="false" 
            data-sharelevel="2" 
            id={`header_${eid}`} 
            onMouseDown={this.handleDragStart}>
              <span className="icon" id={`icon_${eid}`} style={{position:'absolute',cursor:'pointer'}}>
                <img alt='' border="0" src={header.iconimg.src} title={header.iconimg.title} onClick={onShowOrHideE.bind(this,eid)}/>
              </span>
              <span className={fontStyle.titlefontsize ? `wea-f${fontStyle.titlefontsize} title` : 'title'} id={`title_${eid}`} style={{position:'absolute', lineHeight: 1}}>
                  <font class="title-font" id={`element_title_name_${eid}`} dangerouslySetInnerHTML={{__html:header.title}}></font>
                  <span id={`count_${eid}`}></span>
              </span>
            {
                  header.displayPosition && header.displayPosition == 'right' && <div id={`titleContainer_${eid}`} className={`titlecontainer ${className}`} style={{position: 'relative', left: `${left}px`,
                      width: `calc(100% - ${width}px)`, zIndex: '1', backgroundColor: 'white'}}>
                      <TitleTabPane datas={datas} fontStyle={fontStyle} ebaseid={ebaseid}/>
                  </div>
              }
              <Toolbar datas={datas} config={config} handleDelete={handleDelete} handleRefresh={handleRefresh} getElementStyle={this.props.getElementStyle}/>
              <span className="toolbarSub" id={`toolbarSub_${eid}`}></span>
        </div>
  }
}
import { WeaErrorPage, WeaTools } from 'ecCom';
class MyErrorHandler extends React.Component {
  render() {
    const hasErrorMsg = this.props.error && this.props.error !== "";
    return (
      <WeaErrorPage msg={hasErrorMsg ? this.props.error:getLabel(385218,"对不起，该页面异常，请联系管理员！")} />
    );
  }
}
EHeader = WeaTools.tryCatch(React, MyErrorHandler, { error: "" })(EHeader);
export default EHeader;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/EHeader.js